import { createApiRequest, updateDataSetInfo } from 'js/actions/dataSets';
import { refreshPipeline } from 'js/actions/pipelines';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { showAlert } from 'new/stores/showAlert/action';

interface EndpointSpec {
  route?: string;
  query_parameters?: any[];
  headers?: any[];
  body?: any;
}

export const useCreateApiRequest = () => {
  const dispatch = useAppDispatch();

  const createApiRequestNode = (data: any, method: string) => {
    const { data_source_id: sourceId, origin_node_id: flowId } = data;
    return dispatch(createApiRequest(sourceId, method)).then((response) => {
      // wait for pipeline refresh to complete before resolving
      return dispatch(refreshPipeline(flowId)).then(() => {
        dispatch(
          showAlert({
            title: 'API Request created successfully',
            severity: 'success',
          }),
        );
        return response.result;
      });
    });
  };

  const updateRequestEndpointSpec = (datasetId: number, endpointSpec: EndpointSpec) => {
    const payload = {
      endpoint_spec: endpointSpec,
    };
    return dispatch(updateDataSetInfo(datasetId, payload)).then((response) => {
      dispatch(
        showAlert({
          title: 'API endpoint configuration saved successfully',
          severity: 'success',
        }),
      );
      return response;
    });
  };

  return {
    createApiRequestNode,
    updateRequestEndpointSpec,
  };
};
